import { useMemo } from 'react';
import { PRO_MODES, type ProModeId, type ProSectionId } from '@slims-pro/ui/organisms';
import { useMe } from '@/hooks/use-me';
import { useMeta } from '@/hooks/use-meta';
import { MODULE_PAGES } from '@/generated/modules';
import { effectiveMode } from '@/mappers/scope';
import { builtModules } from '@/modules/home';
import { usePlantStore } from '@/stores/plant-store';

/**
 * The permitted sections and modes (both loaded by ProtectedRoute before the shell) and the
 * mode in effect: the single source for the shell and for `useScope`.
 */
export function useModes() {
	const meta = useMeta().data;
	const me = useMe().data;
	const stored = usePlantStore((s) => s.mode);
	const permissions = me?.permissions;
	const enabled = useMemo(
		// Permitted and in this build (ADR-017): never a nav entry without a route.
		() =>
			builtModules<ProSectionId>(
				(permissions ?? []).map((p) => p.module),
				(id) => id in MODULE_PAGES,
			),
		[permissions],
	);
	const modes = PRO_MODES.filter((m) => enabled.has(m.id));
	const mode: ProModeId = effectiveMode(
		stored,
		modes.map((m) => m.id),
		meta?.defaultMode ?? 'fleet',
	);
	return { enabled, modes, mode };
}
